
import { Component, Vue } from "vue-property-decorator";
import HomeCard from "@/components/HomeCard.vue";

@Component({
  components: {
    HomeCard
  }
})
export default class Home extends Vue {
  private mounted() {
    window.scroll(0, 0);
  }
}
